<script lang="ts" setup>
import { useResponsive } from "@composables"
import { TRACKING_EVENTS } from "@constant"
import { TrackingPlugin } from "@plugins/tracking.plugin"
import { useFormStore } from "@stores/form.store"
import { inject, onActivated } from "vue"

const { fetchSendFinalMail, snapshot } = useFormStore()

const { $track } = inject<TrackingPlugin>("tracking")!

onActivated(async () => {
    await fetchSendFinalMail.fetch()
    $track(TRACKING_EVENTS.STEP_ENTERED, {
        step: snapshot.value.context.step + 1,
        formId: "",
    })
})

const { isMobile } = useResponsive()
</script>

<template>
    <FormCard class="step-finally" :footer-btn="false">
        <template #header>
            <div class="step-finally__header">
                <h1 v-if="!isMobile">
                    Envoyé <span class="pi pi-check-circle"></span>
                </h1>
                <h2 class="flex flex-col-reverse items-center md:flex-row">
                    Merci de votre participation
                    <img
                        src="https://res.cloudinary.com/dcoutwkb1/image/upload/w_200,q_auto,f_auto/v1745852809/icon_handcheck_qczxbs.png"
                        alt="handcheck icon"
                    />
                </h2>
            </div>
        </template>
        <div class="step-finally__content">
            <h4>Et maintenant ?</h4>
            <p>
                Le Centre Scientifique et Technique du Bâtiment (CSTB) va
                maintenant analyser les informations que vous avez transmises.
            </p>
        </div>
        <p class="step-finally__link">
            Nous restons à votre disposition pour toute information
            complémentaire sur
            <BaseButton
                variant="link"
                as="a"
                size="small"
                class="button-link"
                href="mailto:contact@wattwatchers"
                label="contact@wattwatchers.fr"
            />
            et le
            <BaseButton
                variant="link"
                as="a"
                size="small"
                class="button-link"
                href="tel:+33162345467"
                label="+33 01 62 34 54 67"
            />
        </p>
        <p class="step-finally__quit">
            <strong>Vous pouvez quitter cette page.</strong>
        </p>
    </FormCard>
</template>

<style scoped>
.step-finally {
    &:deep(.p-card-content) {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        max-width: 48rem;
        gap: 3.5rem;

        margin: 0 auto;

        padding-top: 3.5rem;
    }

    .step-finally__header {
        display: flex;
        flex-direction: column;
        gap: 1rem;

        padding-bottom: 1rem;
        h1 {
            color: #a1ec7e;
            text-align: center;
            font-size: 2rem;
            font-weight: 400;

            span {
                font-size: 1.4rem;
            }
        }

        h2 {
            display: flex;
            justify-content: center;
            gap: 0.5rem;

            color: var(--p-primary-800);
            text-align: center;
            font-size: 2rem;
            font-weight: 400;

            img {
                display: inline-block;
                width: 3rem;
                height: 3rem;
                aspect-ratio: 1/1;
            }
        }
    }

    .step-finally__content {
        display: flex;
        flex-direction: column;
        gap: 1rem;

        h4 {
            color: var(--p-primary-800);
            text-align: center;
            font-size: 1.25rem;
            font-weight: 700;
        }
        p {
            text-align: center;
            font-weight: 400;
        }
    }

    p {
        color: var(--p-primary-800);
        text-align: center;
    }

    .step-finally__quit {
        font-size: 0.77256rem;
    }

    .step-finally__link {
        font-size: 0.875rem;
        font-weight: 500;

        max-width: 40rem;

        .p-button-link {
            --p-button-sm-padding-y: 0;
            --p-button-sm-padding-x: 0.2rem;
            --p-button-sm-font-size: 0.875rem;
            --p-button-link-color: var(--p-primary-400) !important;
        }
    }
}
</style>
